export default "__VITE_ASSET__DS1lXsLK__"